import { IPaymentContainerState } from "../types.d";
import {
  ADD_DELIVERY,
  ADD_PAYMENT_DETAILS,
  CHANGE_DELIVERY_DETAILS,
  CHANGE_ORDER_TYPE,
  CHANGE_STAGES,
  CHANGE_TABLE_NUMBER,
  IS_COLLECTION_DRAW_OPEN,
  IS_CARD_DETAILS_DRAWER_OPEN,
  IS_DELIVERY_DRAW_OPEN,
  IS_LOADING,
  IS_PAYMENT_DRAWER_OPEN,
  IS_TABLE_SERVICE_OPEN,
  IS_UPDATING_PAYMENT_DETAILS,
  ON_COMPLETE_DELIVERY,
  SELECT_TIME,
  SET_DELIVERY_PRICE,
  SET_MESSAGE,
  SET_SUB_TOTAL_COST,
  SET_TOTAL_PRICE_WITHOUT_TIPS,
  SET_TIP_PRICE,
  SET_TRANSACTION_FEE,
  SET_POSTCODE_CHECK_STATUS,
  SET_CART_TAX,
  SET_CART_INCLUSIVE_TAX,
  SET_SERVICE_TAX,
  SET_SERVICE_INCLUSIVE_TAX,
  SET_DELIVERY_INCLUSIVE_TAX,
  SET_DELIVERY_TAX,
} from "./PaymentActions";

interface IAction {
  type: string;
  payload: any;
}

/**Reducer for the payments container */
function PaymentReducer(state: IPaymentContainerState, action: IAction) {
  switch (action.type) {
    case ADD_DELIVERY:
      return {
        ...state,
        deliveryTimes: action.payload,
      };
    case IS_COLLECTION_DRAW_OPEN:
      return {
        ...state,
        isCollectionDrawOpen: action.payload,
      };
    case ADD_PAYMENT_DETAILS:
      return {
        ...state,
        paymentDetails: action.payload.paymentDetails,
        userHasPaymentDetails: action.payload.userHasPaymentDetails,
      };
    case SELECT_TIME:
      return {
        ...state,
        selectedTime: action.payload,
      };
    case IS_TABLE_SERVICE_OPEN:
      return {
        ...state,
        isTableServiceDrawOpen: action.payload,
      };
    case CHANGE_TABLE_NUMBER:
      return {
        ...state,
        selectedTable: action.payload.tableNumber,
        areaName: action.payload?.areaName,
        isTableServiceDrawOpen: false,
      };
    case CHANGE_ORDER_TYPE:
      return {
        ...state,
        selectedOrderType: action.payload,
      };
    case CHANGE_DELIVERY_DETAILS:
      window.localStorage.setItem(
        "BillingAddress",
        JSON.stringify(action.payload)
      );
      return {
        ...state,
        deliveryAddress: action.payload,
      };
    case ON_COMPLETE_DELIVERY:
      return {
        ...state,
        isDeliveryDrawOpen: false,
        isCollectionDrawOpen: true,
      };
    case IS_DELIVERY_DRAW_OPEN:
      return {
        ...state,
        isDeliveryDrawOpen: action.payload,
      };
    case IS_PAYMENT_DRAWER_OPEN:
      return {
        ...state,
        isPaymentDrawOpen: action.payload,
      };
    case IS_CARD_DETAILS_DRAWER_OPEN:
      return {
        ...state,
        isCardDetailsDrawerOpen: action.payload,
      };
    case CHANGE_STAGES:
      return {
        ...state,
        paymentStages: action.payload,
      };
    case IS_UPDATING_PAYMENT_DETAILS:
      return {
        ...state,
        isUpdatingPaymentDetails: action.payload,
      };
    case SET_SUB_TOTAL_COST:
      return {
        ...state,
        subTotalCost: action.payload,
        totalPrice:
          action.payload +
          state.tipTotal +
          state.transactionFee +
          state.deliveryPrice,
      };
    case SET_TOTAL_PRICE_WITHOUT_TIPS:
      return {
        ...state,
        subTotalCost: action.payload,
        totalPriceWithoutTips:
          action.payload +
          state.tipTotal +
          state.transactionFee +
          state.deliveryPrice,
      };
    case SET_TIP_PRICE:
      const tip = Math.round(action.payload);
      return {
        ...state,
        tipTotal: tip,
        totalPrice:
          tip + state.subTotalCost + state.transactionFee + state.deliveryPrice,
      };
    case SET_TRANSACTION_FEE:
      return {
        ...state,
        transactionFee: action.payload,
        totalPrice:
          action.payload +
          state.subTotalCost +
          state.tipTotal +
          state.deliveryPrice,
      };
    case IS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
      };
    case SET_MESSAGE:
      return {
        ...state,
        message: action.payload,
      };
    case SET_DELIVERY_PRICE:
      return {
        ...state,
        deliveryPrice: action.payload,
        totalPrice:
          action.payload +
          state.subTotalCost +
          state.tipTotal +
          state.transactionFee,
      };
    case SET_POSTCODE_CHECK_STATUS:
      return {
        ...state,
        postcodeCheckStatus: action.payload,
      };
    case SET_CART_TAX:
      return {
        ...state,
        cartItemTaxAmount: action.payload,
      };

    case SET_CART_INCLUSIVE_TAX:
      return {
        ...state,
        cartItemInclusiveTaxAmount: action.payload,
      };
    case SET_SERVICE_TAX:
      return {
        ...state,
        serviceTaxAmount: action.payload,
      };
    case SET_SERVICE_INCLUSIVE_TAX:
      return {
        ...state,
        sericeTaxInclusiveTaxAmount: action.payload,
      };
    case SET_DELIVERY_TAX:
      return {
        ...state,
        deliveryTaxAmount: action.payload,
      };
    case SET_DELIVERY_INCLUSIVE_TAX:
      return {
        ...state,
        deliveryInclusiveTaxAmount: action.payload,
      };
    default:
      return state;
  }
}

export default PaymentReducer;
